"use client";

import { c as _c } from "react/compiler-runtime";
import type { AppLocale } from "@/core/i18n/config";
import { SESSION_TYPE_OPTIONS } from "../../../constants/session-types";
import { useBookingStepperStore } from "../../states/booking-stepper.store";
export function Step1SessionType(t0) {
  const $ = _c(14);
  const {
    locale
  } = t0;
  const isHindi = locale === "hi";
  const sessionType = useBookingStepperStore(_temp);
  const setSessionType = useBookingStepperStore(_temp2);
  const t1 = isHindi ? "\u0906\u092A \u0915\u093F\u0938 \u092C\u093E\u0930\u0947 \u092E\u0947\u0902 \u092C\u093E\u0924 \u0915\u0930\u0928\u093E \u091A\u093E\u0939\u0947\u0902\u0917\u0947?" : "What would you like to talk about?";
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="font-heading text-xl font-semibold text-[#0E2A3A]">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isHindi ? "\u092F\u0939 \u0939\u092E\u0947\u0902 \u0906\u092A\u0915\u0947 \u0932\u093F\u090F \u0938\u0939\u0940 \u0938\u0924\u094D\u0930 \u0924\u0948\u092F\u093E\u0930 \u0915\u0930\u0928\u0947 \u092E\u0947\u0902 \u092E\u0926\u0926 \u0915\u0930\u0924\u093E \u0939\u0948\u0964" : "This helps us tailor the right session for you.";
  let t4;
  if ($[2] !== t3) {
    t4 = <p className="mt-1 text-sm text-slate-500">{t3}</p>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isHindi || $[5] !== sessionType || $[6] !== setSessionType) {
    t5 = SESSION_TYPE_OPTIONS.map(option => {
      const isSelected = sessionType === option.value;
      return <button key={option.value} type="button" onClick={() => setSessionType(option.value)} className={`rounded-2xl border px-4 py-4 text-left text-sm font-medium transition ${isSelected ? "border-[#155A7D] bg-[#155A7D]/10 text-[#155A7D]" : "border-[#EAE5DA] bg-white text-slate-700 hover:border-[#155A7D]/40"}`}>{isHindi ? option.hi : option.en}</button>;
    });
    $[4] = isHindi;
    $[5] = sessionType;
    $[6] = setSessionType;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">{t5}</div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div>{t2}{t4}{t6}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp2(state_0) {
  return state_0.setSessionType;
}
function _temp(state) {
  return state.sessionType;
}